<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Select from 'primevue/select'
import InputGroup from 'primevue/inputgroup'
import InertiaFormField from '@/components/InertiaFormField.vue'

const { t } = useI18n()

defineProps<{
  label: string
  error?: string
  disabled?: boolean
}>()

// simple boolean only
const modelValue = defineModel<boolean>({
  required: true,
})

// Select uses string values, map directly to boolean
const internalValue = computed({
  get() {
    return modelValue.value ? 'true' : 'false'
  },
  set(v: string) {
    modelValue.value = v === 'true'
  },
})

const options = computed(() => [
  { label: t('boolean.yes'), value: 'true' },
  { label: t('boolean.no'), value: 'false' },
])
</script>

<template>
  <InertiaFormField :label :error>
    <InputGroup>
      <Select
        v-model="internalValue"
        :options="options"
        option-label="label"
        option-value="value"
        class="w-full"
        :disabled="disabled" />
    </InputGroup>
  </InertiaFormField>
</template>

<i18n>
{
	"en": {
		"boolean": {
			"yes": "Yes",
			"no": "No"
		}
	},
	"de": {
		"boolean": {
			"yes": "Ja",
			"no": "Nein"
		}
	}
}
</i18n>
